import { tDiscountPercent } from "./interfaces";

export const isReduxShowed: boolean = false;

export const discountPercents = [5, 10, 15] as const;

export const apis: {[key in tDiscountPercent]: {main: string, reserve?: string}} = {
	5: {
		main: 'https://dnt.techno-content.com/sbd_tn_api_v1/'
	},
	10: {
		main: 'https://dnt.techno-content.com/sbd_tn_api_v2/'
	},
	15: {
		main: 'https://dnt.techno-content.com/sbd_tn_api_v3/'
	}
}

// CHR

export const chromiaBackendUrl = 'https://chromia.techno-content.com:10443/dex_backend_tn';	// local
// export const chromiaBackendUrl = 'https://chromia.techno-content.com:10443/dex_backend_chr_tn';	// dev net
// export const chromiaBlockchainRID = '45B5AA2CCC23EE9144BEAC79B7F953945EE3AC5CA6797548704F72E45C303F36';	// local
// export const chromiaBlockchainUrl = 'https://chromia.techno-content.com:10443/bc/';	// local


export const chromiaBlockchainRID = '4AEB5DE8F71A6D6614CCAC582B45931A8A2FB94440810945132EEE3BD231A688';	// quest net
// export const chromiaBlockchainRID = 'CBFA3D2F0A6838ED9E9784C97837DCA204A4205179BF90E28D225ADF51629531';	// dev net
// export const chromiaBlockchainRID = '8AE48FB9662A3DA58B1E5281BEBE1B3BF5AE1B0D1F59A9867DB8D5DC2971D24D';	// local
/* export const chromiaBlockchainUrl = [
	"https://node4.devnet1.chromia.dev:7740",
	"https://node5.devnet1.chromia.dev:7740",
	"https://node6.devnet1.chromia.dev:7740"
	// "https://node7.devnet1.chromia.dev:7740",
]; */
export const chromiaBlockchainUrl = [	// quest
	"https://node0.questnet.chromia.dev:7740",
	"https://node1.questnet.chromia.dev:7740",
	"https://node2.questnet.chromia.dev:7740",
	"https://node3.questnet.chromia.dev:7740"
]
// export const chromiaBlockchainUrl = "http://chromia.techno-content.com:7740";
export const blockchain: 'binance' | 'chromia' = 'chromia';

export const itemIds: {[key in tDiscountPercent]: string} = {	// quest
	5: '788eb239f92a6f28c39040b5630f72fbedcf5ae1ac32f63932e3d82cc4d8cdd6',
	10: 'c9fdaedde90902fd5b2bf774b942a33f6ae12407ff429a42d9b1f83e24c6a283',
	15: '8ee745dfdda89d08d57428f050db158a2c51a89e416615458534f5289a4909e0',
}

export const fTokenIds: {[key in tDiscountPercent]: string} = {	// quest
	5: 'ced37689d626e1238f7f9f750ce80e3f4a863aef2b4f7316e30ea6f2f8f57765',
	10: 'ced37689d626e1238f7f9f750ce80e3f4a863aef2b4f7316e30ea6f2f8f57765',
	15: 'ced37689d626e1238f7f9f750ce80e3f4a863aef2b4f7316e30ea6f2f8f57765',
}

export const KasUrl = 'https://dnt.techno-content.com/front_kas/';
export const projectName = 'SBD_CHR'
export const isProduction = true;